/*
 * @description:
 * @author: Jason Wong
 * @since: 2024-07-11 17:21:02
 */
import ENV from "../../configs/env";
import { createStorage as create } from "./storageCache";
import { enableStorageEncryption, DEFAULT_CACHE_TIME } from "../../configs/encryptionConfig";
import dpkg from "../../../package.json";

function getStorageShortName() {
    console.log("#env", ENV);
    return `${ENV.name}_${dpkg.version}_`.toUpperCase();
}

const createOptions = (storage, options = {}) => {
    return {
        // No encryption in debug mode
        hasEncrypt: enableStorageEncryption,
        storage,
        prefixKey: getStorageShortName(),
        ...options,
    };
};

export const createStorage = (storage = sessionStorage, options = {}) => {
    return create(createOptions(storage, options));
};

export const createSessionStorage = (options = {}) => {
    return createStorage(sessionStorage, { ...options, timeout: DEFAULT_CACHE_TIME });
};

export const createLocalStorage = (options = {}) => {
    return createStorage(localStorage, { ...options, timeout: DEFAULT_CACHE_TIME });
};
